import { render } from "./TranslationRow.vue?vue&type=template&id=6d7f252e"
import script from "./TranslationRow.vue?vue&type=script&lang=js"
export * from "./TranslationRow.vue?vue&type=script&lang=js"
script.render = render

export default script